import {Theme, SxProps} from '@mui/material'
import {SystemStyleObject} from '@mui/system/styleFunctionSx/styleFunctionSx'

import {customThemeConstants} from '../../theme'

export const buttonOnBlueSx: SxProps<Theme> = (theme) => ({
  border: 1,
  borderColor: customThemeConstants().palette.mediumButtonBorder,
  backgroundColor: customThemeConstants().palette.mediumButtonBackground,
  color: theme.palette.common.white,
  padding: 2,
  '&:hover': {
    borderColor: customThemeConstants().palette.mediumButtonBorder,
    backgroundColor: customThemeConstants().palette.mediumButtonBackgroundHover
  },
  '&:active': {
    backgroundColor: customThemeConstants().palette.mediumButtonBackgroundDown
  }
})

export const buttonSx = (theme: Theme): SystemStyleObject<Theme> => ({
  padding: 1,
  borderColor: theme.palette.divider,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  '&:hover': {
    borderColor: theme.palette.divider,
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.primary
  },
  '&:active': {
    borderColor: theme.palette.divider,
    backgroundColor: theme.palette.action.selected,
    color: theme.palette.text.primary
  }
})

export const buttonCheckedSx = (theme: Theme): SystemStyleObject<Theme> => ({
  padding: 1,
  borderColor: theme.palette.text.primary,
  backgroundColor: theme.palette.text.primary,
  color: theme.palette.background.paper,
  '&:hover': {
    borderColor: theme.palette.text.primary,
    backgroundColor: theme.palette.text.primary,
    color: theme.palette.background.paper
  },
  '&:active': {
    borderColor: theme.palette.text.primary,
    backgroundColor: theme.palette.text.primary,
    color: theme.palette.background.paper
  }
})
